import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { customerFeatureGuard } from './auth/customer-feature.guard';
import { HomeComponent } from './marketing/home/home.component';
import { AboutComponent } from './marketing/about/about.component';
import { ContactComponent } from './marketing/contact/contact.component';
import { LoginPageComponent } from './auth/login-page.component';
import { ForgotPasswordComponent } from './auth/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password.component';
import { RegisterAgentComponent } from './auth/register-agent.component';
import { RegisterCustomerComponent } from './auth/register-customer.component';
import { IrrigationInsuranceComponent } from './marketing/irrigation-insurance/irrigation-insurance.component';
import { FormsComponent } from './marketing/forms/forms.component';
import { GetQuoteComponent } from './marketing/get-quote/get-quote.component';
import { UnimplementedRouteComponent } from './unimplemented-route/unimplemented-route.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'contact', component: ContactComponent },

  // Public pages
  { path: 'irrigation-insurance', component: IrrigationInsuranceComponent },
  { path: 'forms', component: FormsComponent },
  { path: 'get-quote', component: GetQuoteComponent },

  // Auth pages
  { path: 'login', component: LoginPageComponent },
  { path: 'register', component: RegisterAgentComponent },
  { path: 'register-customer', canActivate: [customerFeatureGuard], component: RegisterCustomerComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },

  // Agent area — lazy loaded
  {
    path: 'agent',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./agent/agent.module').then((m) => m.AgentModule),
  },

  // Admin area — lazy loaded
  {
    path: 'admin',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },

  // Customer area — lazy loaded
  {
    path: 'customer',
    canActivate: [customerFeatureGuard, authGuard],
    loadChildren: () =>
      import('./customer/customer.module').then((m) => m.CustomerModule),
  },

  // Quote area — lazy loaded
  {
    path: 'quote',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./quote/quote.module').then((m) => m.QuoteModule),
  },

  { path: '**', component: UnimplementedRouteComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
